import { createFileRoute } from '@tanstack/react-router';

import { MyProfilePage } from '@/features/me/my-work';

export const Route = createFileRoute('/_app/me/profile')({ component: MyProfilePage });
